import Vue from 'vue'
import Router from 'vue-router'
import Store from './store/index'
import {userService} from "./services";

const Login = () => import('./views/Login');
const FirstLoginNewStore = () => import('./views/FirstLoginNewStore');
const ForgotPassword = () => import('./views/ForgotPassword');
const ForgotPasswordNew = () => import('./views/ForgotPasswordNew');
const ForgotPIN = () => import('./views/ForgotPin');
const Account = () => import('./views/Account');
const EmailSent = () => import('./views/EmailSent');
const ApplicationConsents = () => import('./views/ApplicationConsents');
const SelectDocumentType = () => import('./views/SelectDocumentType');

const ConfirmInProgress = () => import(/* webpackChunkName: "group-link-account" */'./views/ConfirmInProgress');

const CreateAccountSelect = () => import(/* webpackChunkName: "group-registration" */'./views/CreateAccountSelect');
const CreateAccountNoCard = () => import(/* webpackChunkName: "group-registration" */'./views/CreateAccountNoCard');
const CreateAccountPickCard = () => import(/* webpackChunkName: "group-registration" */'./views/CreateAccountPickCard');
const CreateAccountWithCard = () => import(/* webpackChunkName: "group-registration" */'./views/CreateAccountWithCard');
const CreateAccountConsents = () => import(/* webpackChunkName: "group-registration" */'./views/CreateAccountConsents');
const DigitalOnBoarding = () => import(/* webpackChunkName: "group-registration" */'./views/DigitalOnBoarding');


Vue.use(Router);

var router = new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/potrdi-email/:confirm_code*',
            name: 'confirm',
            component: ConfirmInProgress
        },
        {
            path: '/prva-prijava',
            name: 'first_login_new_store',
            component: FirstLoginNewStore
        },
        {
            path: '/prva-prijava-kartica',
            name: 'first_login_new_store_card',
            meta: {
                card: true
            },
            component: FirstLoginNewStore
        },
        {
            path: '/ustvari/izbira',
            name: 'create_account_select',
            component: CreateAccountSelect
        },
        {
            path: '/ustvari/podjetje',
            name: 'create_account_no_card',
            component: CreateAccountNoCard
        },
        {
            path: '/ustvari/kartica',
            name: 'create_account_pick_card',
            component: CreateAccountPickCard
        },
        {
            path: '/ustvari/kartica/izbrana',
            name: 'create_account_pick_card',
            component: CreateAccountWithCard
        },
        {
            path: '/ustvari/privolitve',
            name: 'create_account_consents',
            component: CreateAccountConsents
        },
        {
            path: '/pozabljeno-geslo',
            name: 'forgot_password',
            component: ForgotPassword
        },
        {
            path: '/pozabljena-pin',
            name: 'forgot_password',
            component: ForgotPIN
        },
        {
            path: '/novo-geslo',
            name: 'forgot_password_new',
            component: ForgotPasswordNew
        },
        {
            path: '/racun',
            name: 'account',
            component: Account
        },
        {
            path: '/racun/varnost',
            name: 'account-security',
            component: Account
        },
        {
            path: '/racun/soglasja',
            name: 'account-consents',
            component: Account
        },
        {
            path: '/poslan-email',
            name: 'email_sent',
            component: EmailSent
        },
        {
            path: '/storitev/soglasje',
            name: 'application_consents',
            component: ApplicationConsents
        },
        {
            path: '/tip-dokumenta',
            name: 'select_document_type',
            component: SelectDocumentType
        },
        {
            path: '/vclanitev',
            name: 'digital_onboarding',
            component: DigitalOnBoarding
        },
    ]
});

const ALLOW_FOR_ANONY_USERS = [
    'login', 'forgot_password', 'join_club_account', 'join_club_other', 'join_club_personal', 'create_account',
    'create_account_select', 'email_sent', 'forgot_password_new', 'application_consents', 'link_account_card'
];
const ALLOW_FOR_AUTH_USERS = [
    'account', 'link_account_card', 'join_club_personal', 'join_club_other', 'join_club_account', 'application_consents', 'digital_onboarding'
];


const AUTH_CHECK_TIMEOUT = 10000;

// On a direct page load auth/me is still pending, so wait for it before deciding on auth-only routes.
function waitForAuthCheck() {
    if (Store.state.auth.authenticated_checked) {
        return Promise.resolve();
    }
    return new Promise(resolve => {
        let timeout = null;
        const unwatch = Store.watch(
            state => state.auth.authenticated_checked,
            checked => {
                if (checked) {
                    clearTimeout(timeout);
                    unwatch();
                    resolve();
                }
            }
        );
        timeout = setTimeout(() => {
            unwatch();
            resolve();
        }, AUTH_CHECK_TIMEOUT);
    });
}

router.beforeEach((to, from, next) => {
    if (to.name == 'confirm') {
        return next();
    } /*else if(to.name == 'account'){
        window.location.replace('https://www.tus.si/uporabniski-profil');
    }*/ else {
        const auth_only = ALLOW_FOR_AUTH_USERS.indexOf(to.name) > -1 && ALLOW_FOR_ANONY_USERS.indexOf(to.name) == -1;
        const check = auth_only ? waitForAuthCheck() : Promise.resolve();
        check.then(() => {
            let is_authenticated = Store.state.auth.authenticated;
            if (auth_only && is_authenticated == false) {
                if (to.name == 'digital_onboarding') {
                    // anonymous users have to register first; onboarding step follows after consents.
                    return next({path: '/ustvari/podjetje', query: {next: to.path}});
                }
                return next('login');
            } else if (ALLOW_FOR_ANONY_USERS.indexOf(to.name) > -1 && ALLOW_FOR_AUTH_USERS.indexOf(to.name) == -1 && is_authenticated) {
                //return next('racun');
            }
            if (to.name == null) {
                return next('/');
            }
            return next();
        });
    }

});


export default router;
